import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useNewAdminModal } from '../use-new-admin-modal';
import { EmailTagsField } from './email_tags_field';
import { SubmitButton } from './submit_button';

// Formik doesn't support disabling inputs, and the cui text input is too short
const disabledInputCss = "dtle27y";
const DisabledInput = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'input';
  return <Component ref={ref} {...restProps} className={classNames(disabledInputCss, props.className)} />;
});
const containerCss = "c1ijcgrs";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const EmailsField = ({
  maxSeats,
  onChange,
  inlineRoleSelect,
  showNoEmailsError = false
}) => {
  const isAdminFlagEnabled = useNewAdminModal();
  return <>
      {!isAdminFlagEnabled && <BodyText size="large" weight="bold">
        {I18n.t('publisher.add_users_modal.email_field_label')}
      </BodyText>}
      {maxSeats > 0 && <EmailTagsField maxSeats={maxSeats} singleRow placeholderText={I18n.t('publisher.add_users_modal.email_field_placeholder')} showNoEmailsError={showNoEmailsError} onChange={onChange} inlineRoleSelect={inlineRoleSelect} />}
      {maxSeats === 0 && <DisabledInput id="invite-user-modal-input-field" disabled placeholder={I18n.t('publisher.add_users_modal.email_field_placeholder')} />}
      {isAdminFlagEnabled && <Container>
          <SubmitButton />
        </Container>}
    </>;
};

require("./emails_field.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./emails_field.js");